import { Map, View } from 'ol'
import Select from 'ol/interaction/Select'
import Graticule from 'ol/layer/Graticule'
import Group from 'ol/layer/Group'
import TileLayer from 'ol/layer/Tile'
import 'ol/ol.css'
import { transform, transformExtent } from 'ol/proj'
import { register } from 'ol/proj/proj4'
import XYZ from 'ol/source/XYZ'
import Fill from 'ol/style/Fill'
import Stroke from 'ol/style/Stroke'
import Style from 'ol/style/Style'
import proj4 from 'proj4'

/**
 * 基于openlayers的地图应用
 * @author xunyi
 */
var Map2d = (function () {
  function Map2d (options) {
    if (options) {
      this.options = options
    } else {
      throw new Error('没有任何配置！')
    }
    this.map = null
    // 当前地图名称
    this.currentMapEname = undefined
    // 已加载的地图
    this.mapCaches = {}
    // 经纬网
    this.graticule = undefined
    // 把整个地图应用配置成5大层级(由低向上)，依次为地图、产品组、经纬网、画板、覆盖物
    this.layerLevel = { map: 1, product: 2, graticule: 3, draw: 4, overlay: 5 }
    // 高产品图层组，等级为100及以上
    this.highLayerLevel = {}
    if (options.highLayerLevel) {
      const highLayerLevel = options.highLayerLevel
      // for (const item in highLayerLevel) {
      //   if (highLayerLevel[item] < 100) {
      //     throw new Error('高产品图层组，等级为100及以上')
      //   }
      // }
      this.highLayerLevel = highLayerLevel
    }
    // 低产品图层组，等级为1-10
    this.lowLayerLevel = {}
    if (options.lowLayerLevel) {
      const lowLayerLevel = options.lowLayerLevel
      // for (const item in lowLayerLevel) {
      //   if (lowLayerLevel[item] < 1 || lowLayerLevel[item] > 10) {
      //     throw new Error('低产品图层组，等级为1-10')
      //   }
      // }
      this.highLayerLevel = lowLayerLevel
    }
    // 初始化当前
    this.currentLayerLevel = 20
    this.screenInfo = {}
    this.init()
  }
  Map2d.prototype = {
    /**
         * 初始化
         */
    init () {
      const _this = this
      // _this.addProjection("EPSG:3395", "+proj=merc +lon_0=0 +k=1 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs");
      _this.map = new Map({
        target: 'map',
        view: _this.setView()
      })
      // 地图
      const map = _this.options.map
      if ((!map || typeof map !== 'object') && map.length <= 0) {
        throw new Error('请配置:options.map')
      }
      _this.changeMap(0)
      // 单击
      _this.map.on(['singleclick', 'pointermove'], function (event) {
        _this.map.forEachFeatureAtPixel(event.pixel, function (feature) {
          feature.dispatchEvent({ type: event.type, event: event })
        })
      })
    },
    /**
     * 设置视图
     */
    setView () {
      const _this = this
      const view = _this.options.view
      if (!view) {
        throw new Error('请配置:options.view')
      }
      if (!view.center) {
        throw new Error('请配置:options.view.center')
      }
      if (!view.projection) {
        throw new Error('请配置:options.view.projection')
      }
      if (!view.zoom) {
        throw new Error('请配置:options.view.zoom')
      }
      let center = view.center
      if (view.centerProjection) {
        center = transform(center, view.centerProjection, view.projection)
      }
      const viewOptions = {
        center: center,
        projection: view.projection,
        zoom: view.zoom,
        // 设置缩放级别为整数
        constrainResolution: true,
        // 关闭无极缩放
        smoothResolutionConstraint: false
      }
      if (view.minZoom) {
        viewOptions.minZoom = view.minZoom
      }
      if (view.maxZoom) {
        viewOptions.maxZoom = view.maxZoom
      }
      return new View(viewOptions)
    },
    /**
     * 设置经纬网
     * @param {boolean} flag true为显示
     */
    setGraticule (flag) {
      const _this = this
      const graticule = _this.options.graticule
      if (!graticule) {
        throw new Error('请配置options.graticule')
      }
      if (!graticule.strokeColor) {
        throw new Error('请配置options.graticule.strokeColor')
      }
      if (!graticule.strokeWidth) {
        throw new Error('请配置options.graticule.strokeWidth')
      }
      if (!graticule.targetSize) {
        throw new Error('请配置options.graticule.targetSize')
      }
      if (!_this.graticule) {
        _this.graticule = new Graticule({
          strokeStyle: new Stroke({ color: graticule.strokeColor, width: graticule.strokeWidth }),
          targetSize: graticule.targetSize,
          showLabels: true,
          wrapX: false,
          zIndex: _this.layerLevel.graticule
        })
        _this.map.addLayer(this.graticule)
      }
      _this.graticule.setVisible(flag)
    },
    /**
     * 获取鼠标当前的信息
     * @param {String} eventname 事件名称
     * @param {function} callback 回调函数
     * @param {String} scope 限制范围 选填
     * @param {boolean} area 是否区域选择
     */
    getPosintionInfo (eventname, callback, scope, area) {
      const _this = this
      _this.map.on(eventname, function (event) {
        var pixel = _this.map.getEventPixel(event.originalEvent)
        var feature = _this.map.forEachFeatureAtPixel(pixel, function (feature) { return feature })
        var result = {}
        if (feature !== undefined) {
          result.name = feature.get('name')
          result.city = feature.get('city')
          result.district = feature.get('district')
          result.province = feature.get('province')
          result.town = feature.get('town')
        }
        if (scope !== undefined) {
          var features = _this.map.getFeaturesAtPixel(pixel)
          var flag = false
          for (var i in features) {
            var name = features[i].get('name')
            if (name === scope) {
              flag = true
              break
            }
          }
          if (flag) {
            result.coordinate = event.coordinate
            callback(result)
          } else {
            callback()
          }
        } else {
          result.coordinate = event.coordinate
          callback(result)
        }
      })
      if (area) {
        var select = new Select({
          style: new Style({
            fill: new Fill({ color: 'rgba(0,0,255,0.1)' })
          }),
          filter: function (feature) {
            if (feature.get('mark') === 'map') {
              return true
            } else {
              return false
            }
          }
        })
        _this.map.addInteraction(select)
      }
    },
    /**
     * 切换地图
     * @param {Object} map 地图配置
     */
    changeMap (index) {
      const _this = this
      const map = _this.options.map[index]
      if (!map.ename) {
        throw new Error('请配置:options.map[].ename')
      }
      if (!map.url) {
        throw new Error('请配置:options.map[].url')
      }
      let projection = map.projection
      if (!projection) {
        projection = _this.options.view.projection
      }
      // 隐藏
      if (_this.currentMapEname) {
        _this.mapCaches[_this.currentMapEname].setVisible(false)
      }
      // 显示
      const mapCache = _this.mapCaches[map.ename]
      if (!mapCache) {
        const urls = map.url
        const layers = []
        for (let i = 0; i < urls.length; i++) {
          const layer = new TileLayer({
            // className: 'blueLayer',
            source: new XYZ({
              // crossOrigin: 'anonymous',
              url: urls[i],
              wrapX: false,
              tilePixelRatio: 2,
              minZoom: map.minZoom,
              maxZoom: map.maxZoom
              // projection: projection
            })
          })
          layers.push(layer)
        }
        const group = new Group({
          layers: layers,
          zIndex: _this.layerLevel.map
        })
        _this.map.addLayer(group)
        _this.mapCaches[map.ename] = group
      } else {
        mapCache.setVisible(true)
      }
      _this.currentMapEname = map.ename
    },
    /**
     * 获取图层等级
     * @param {String} productName 产品名称
     */
    getLayerLevel (productName) {
      const _this = this
      if (_this.highLayerLevel[productName]) {
        return _this.highLayerLevel[productName]
      }
      if (_this.lowLayerLevel[productName]) {
        return _this.lowLayerLevel[productName]
      }
      return ++_this.currentLayerLevel
    },
    /**
     * 获取屏幕信息（坐上右下经纬度，以及像素）
     * @param {String} formatProjection 指定输出格式
     */
    getScreenInfo (formatProjection) {
      const _this = this
      const startPixel = [0, 0]
      const endPixel = _this.map.getSize()
      let startCoordinate = _this.map.getCoordinateFromPixel(startPixel)
      let endCoordinate = _this.map.getCoordinateFromPixel(endPixel)
      const extent = [startCoordinate[0], endCoordinate[1], endCoordinate[0], startCoordinate[1]]
      if (_this.options.view.centerProjection) {
        startCoordinate = transform(startCoordinate, _this.options.view.projection, formatProjection)
        endCoordinate = transform(endCoordinate, _this.options.view.projection, formatProjection)
      }
      _this.screenInfo = { minLon: startCoordinate[0], maxLat: startCoordinate[1], maxLon: endCoordinate[0], minLat: endCoordinate[1], width: endPixel[0], height: endPixel[1], extent: extent }
    },

    /**
     * 添加坐标系
     * 例如：code:"EPSG:3395",codeInfo:"+proj=merc +lon_0=0 +k=1 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs"
     * 具体参考：http://epsg.io/3395
     * @param {String} code
     * @param {String} codeInfo
     */
    addProjection (code, codeInfo) {
      proj4.defs(code, codeInfo)
      register(proj4)
    },
    /**
     * 通过坐标系转换范围
     * @param {Array} extent 范围
     * @param {String} source  数据源坐标系
     */
    transformExtentByProjection (extent, source) {
      const _this = this
      const destination = _this.options.view.projection
      if (destination !== source) {
        return transformExtent(extent, source, destination)
      } else {
        return extent
      }
    }
  }
  return Map2d
}())
export default Map2d
